/* search.js — Pique Vitality. Predictive search drawer (progressive enhancement).
   Uses the Section Rendering API: /search/suggest?…&section_id=predictive-search */
(function () {
  'use strict';

  const drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;

  const input = drawer.querySelector('[data-predictive-input]');
  const results = drawer.querySelector('[data-predictive-results]');
  const defaultPanel = drawer.querySelector('[data-predictive-default]');
  const clearBtn = drawer.querySelector('[data-predictive-clear]');
  const form = drawer.querySelector('[data-predictive-form]');
  const recentWrap = drawer.querySelector('[data-recent-wrap]');
  const recentList = drawer.querySelector('[data-recent-list]');
  const RECENT_KEY = 'pique:recent-searches';

  const live = document.createElement('div');
  live.setAttribute('data-predictive-live', '');
  live.hidden = true;
  results.appendChild(live);

  /* ---- open / close ---- */
  function open(e) {
    if (e) e.preventDefault();
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    renderRecent();
    setTimeout(() => input && input.focus(), 60);
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  document.querySelectorAll('[data-search-toggle]').forEach((b) => b.addEventListener('click', open));
  drawer.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close(); });

  /* ---- recent searches (localStorage) ---- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    let list = getRecent().filter((t) => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    list = list.slice(0, 5);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    if (!recentWrap || !recentList) return;
    const list = getRecent();
    if (!list.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    recentList.innerHTML = list.map((t) => {
      const url = '/search?q=' + encodeURIComponent(t);
      return '<li><a href="' + url + '">↩ ' + escapeHtml(t) + '</a></li>';
    }).join('');
  }
  function escapeHtml(s) { return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  /* ---- predictive fetch (debounced) ---- */
  let timer = null;
  let controller = null;

  function showDefault() {
    if (defaultPanel) defaultPanel.hidden = false;
    live.hidden = true;
    live.innerHTML = '';
    if (clearBtn) clearBtn.hidden = true;
  }

  async function predict(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    const url = '/search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,article,query' +
      '&resources[limit]=6';
    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error('suggest failed');
      const html = await res.text();
      live.innerHTML = html;
      live.hidden = false;
      if (defaultPanel) defaultPanel.hidden = true;
    } catch (e) {
      if (e.name !== 'AbortError') showDefault();
    }
  }

  if (input) {
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { showDefault(); return; }
      timer = setTimeout(() => predict(q), 220);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => { input.value = ''; input.focus(); showDefault(); });
  }

  if (form) {
    form.addEventListener('submit', () => { saveRecent(input.value); });
  }
})();
